
let email_ticket = document.getElementById('email_ticket');

if( email_ticket ){

email_ticket.onclick = function( event ) {

    event.preventDefault();

    let target = event.target;

    let ticket_id = target.getAttribute('data-ticket');
    let event_id = target.getAttribute('data-event');

    const alert_area = document.getElementById('account-alerts');

    grecaptcha.ready(function() {

        grecaptcha.execute( reCAPTCHA.site_key , {action: 'submit'}).then(function(token) {

            var form_data = new FormData();
            form_data.append( 'token', token);
            form_data.append( 'action', 'send_ticket');
            form_data.append( 'ticket_id', ticket_id);
            form_data.append( 'event_id', event_id);

            jQuery.ajax({
                type: 'POST',
                contentType: false,
                processData: false,
                url: theme.ajax,
                data: form_data,

                beforeSend: function(){

                    target.setAttribute('disabled', 'disabled');

                },
        
                success: function( response ){

                    response = JSON.parse( response );


                    if( response.success ){

                        let alert_div = document.createElement('div');
                        alert_div.classList.add('alert', 'alert-success' );
                        alert_div.setAttribute( 'role', 'alert');

                        alert_div.innerHTML = response.success_message;

                        alert_area.append( alert_div );

                    } else {

                        let alert_div = document.createElement('div');
                        alert_div.classList.add('alert', 'alert-error' );
                        alert_div.setAttribute( 'role', 'alert');

                        alert_div.innerHTML = response.error_message;

                        alert_area.append( alert_div );

                    }

                    target.removeAttribute('disabled');


                }

            });
            
        });

      });
 
 }
}